"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroup = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _ = require(".");
var _ErrorMessage = _interopRequireDefault(require("../ErrorMessage"));
var _Hint = _interopRequireDefault(require("../Hint"));
var _checkbox = require("./checkbox.style");
var _Label = _interopRequireDefault(require("../Label"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CheckboxGroup = exports.CheckboxGroup = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      className = 'checkboxGroup',
      options = [],
      orientation = 'horizontal',
      disabled = false,
      hint,
      label,
      maxSelectionLimit,
      onChange,
      value,
      name,
      error,
      fit = 'medium',
      type
    } = props,
    rest = __rest(props, ["className", "options", "orientation", "disabled", "hint", "label", "maxSelectionLimit", "onChange", "value", "name", "error", "fit", "type"]);
  const handleOnChange = (e, index) => {
    // Update the checked value with index
    const updatedOptions = options.map((option, indexOption) => {
      if (index === indexOption) {
        return (0, _extends2["default"])((0, _extends2["default"])({}, option), {
          checked: e.target.checked
        });
      } else {
        return (0, _extends2["default"])((0, _extends2["default"])({}, option), {
          checked: isOptionChecked(option)
        });
      }
    });
    if (onChange) {
      onChange(e, updatedOptions, type);
    }
  };
  const isOptionChecked = option => {
    return Array.isArray(value) ? value.indexOf(option.value) > -1 : option.checked || false;
  };
  return (0, _jsxRuntime.jsxs)(_checkbox.StyledFieldSet, (0, _extends2["default"])({
    className: className
  }, {
    children: [label && (0, _jsxRuntime.jsx)(_Label["default"], (0, _extends2["default"])({
      label: label,
      fit: fit,
      orientation: orientation
    }, rest)), error && (0, _jsxRuntime.jsx)(_ErrorMessage["default"], (0, _extends2["default"])({
      fit: fit
    }, rest)), hint && (0, _jsxRuntime.jsx)(_Hint["default"], (0, _extends2["default"])({
      hint: hint,
      fit: fit
    }, rest)), (0, _jsxRuntime.jsx)(_checkbox.StyledGroupCheckboxContainer, (0, _extends2["default"])({
      display: "flex",
      flexDirection: orientation === 'vertical' ? 'column' : 'row',
      mt: 2,
      orientation: orientation,
      fit: fit
    }, {
      children: options.map((option, index) => (0, _jsxRuntime.jsx)(_.CheckboxStandard, (0, _extends2["default"])({
        error: error,
        name: name
      }, option, {
        checked: isOptionChecked(option),
        onChange: e => handleOnChange(e, index),
        disabled: (disabled !== false ? disabled : !!option.disabled) || (maxSelectionLimit && !isOptionChecked(option) ? (value || []).length >= maxSelectionLimit : false),
        fit: fit,
        ref: ref
      }), "".concat(option.value, "-").concat(index)))
    }))]
  }));
});